import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./designSystem/designSystem.css";
import "./designSystem/auth.css";
import App from "./App";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import { WalletProvider } from "./context/walletContext";
import { AuthProvider } from "./context/authContext";
import { LoaderProvider, useLoader } from "./context/loaderContext";
import { ThemeProviderCustom, useThemeMode } from "./context/ThemeContext";
import { BrandingProvider, useBranding } from "./context/BrandingContext";
import { NotificationProvider } from "./context/NotifyContext";
import { ThemeProvider as MuiThemeProvider, CssBaseline } from "@mui/material";
import { getTheme } from "./theme";
import { setLoader } from "./api/axiosInstance";
import GlobalLoader from "./components/Loader/GlobalLoader";

const LoaderBridge = () => {
  const { loading, setLoading } = useLoader();
  const initialized = useRef(false);
  useEffect(() => {
    if (!initialized.current) {
      setLoader(setLoading);
      initialized.current = true;
    }
  }, [setLoading]);
  return loading ? <GlobalLoader /> : null;
};

const ThemedApp = () => {
  const { mode } = useThemeMode();
  const { settings } = useBranding();
  const theme = getTheme(mode, settings || {});

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LoaderProvider>
            <AuthProvider>
              <LoaderBridge />
              <WalletProvider>
                <NotificationProvider>
                  <App />
                </NotificationProvider>
              </WalletProvider>
            </AuthProvider>
          </LoaderProvider>
        </PersistGate>
      </Provider>
    </MuiThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProviderCustom>
    <BrandingProvider>
      <ThemedApp />
    </BrandingProvider>
  </ThemeProviderCustom>
);
